// Backend base URL. Blank = the app talks to Traccar directly with the token
// baked in (fine for local/private testing only). Once the TagAlong backend is
// deployed, set this to its URL (e.g. https://tagalong-backend.onrender.com) and
// the app routes tracking through it — the token then lives ONLY on the server.
// REACT_APP_API_BASE (build-time) lets a local run point at a test backend;
// it is unset in production, so the deployed app always uses the live server.
export const API_BASE = process.env.REACT_APP_API_BASE || 'https://tagalong-backend-fdzx.onrender.com';

// Google Maps key — restricted to localhost:3000 and gps.dynamicsbpo.com in the
// Google Cloud console, so it can only load maps from your own sites.
export const GOOGLE_MAPS_KEY = 'AIzaSyDuxhKLaiauw4P5c8R1LTsMfm-E5HF5sck';

// SEPARATE key for the NATIVE iOS/Android app (native Google Maps SDK). A Google
// key can only have one restriction type, so the native app needs its own key
// restricted to "iOS apps" (bundle id com.dynamicsbpo.tagalong) with Maps SDK for
// iOS enabled. Safe to keep here — it's bundle-locked. Paste the new key here.
export const GOOGLE_MAPS_KEY_IOS = 'AIzaSyBelidTnSbfmo6z7kGTnY7JSVh3j7VZNdA';

// Free image host for the broker community photos (car feed + Do-Not-Rent).
// Get a free key at https://api.imgbb.com (sign up → API → get key), paste it
// here. With a key set, full-size photos upload to the host and only a tiny URL
// is stored in the shared record — no size limit, full quality for every broker.
// Left blank, the app falls back to a small inline thumbnail.
export const IMGBB_KEY = '';

// Email sending. Left blank, the app opens YOUR email app pre-filled (you hit
// send). Once the backend is live, set this to your send endpoint (e.g.
// https://api.yourdomain.com/email) and emails go out automatically — invoices,
// receipts, contract-to-sign links, and password resets — no manual step.
export const EMAIL_ENDPOINT = '';

// --- Automatic email WITHOUT a backend, via EmailJS (emailjs.com) ---
// Free tier ~200 emails/month. Sign up, connect your email, create a template,
// then paste the three IDs below. With all three set, the app sends emails
// automatically (invoices, receipts, contracts). Leave blank to use the mail app.
export const EMAILJS_SERVICE = '';      // e.g. service_ab12cde
export const EMAILJS_TEMPLATE = '';     // e.g. template_xy34fgh
export const EMAILJS_PUBLIC_KEY = '';   // e.g. AbCdEfGhIjKlMnОp
